import React, { useEffect, useState } from "react";
import { FiPlusCircle } from "react-icons/fi";
import * as Dialog from "@radix-ui/react-dialog";
import { useUserAuth } from "../../context/UserAuthContext";
import { useData } from "../../context/DataContext";
import { generateHTML } from "../../../common/methods";
import { MdOutlinePlayCircleFilled } from "react-icons/md";
import * as Popover from "@radix-ui/react-popover";
import { FaFilter } from "react-icons/fa";
import { PiEmptyBold } from "react-icons/pi";

const availableColors = [
  "#ffffff", "#fad154", "#61d1ff", "#d1d9c9",
  "#f7bfff", "#d4e0e3", "#ffc27d", "#ffa8b3",
  "#cfc4ff", "#1a1a1a", "#0096a8", "#ff9c00", "#2175ff",
  "#581845", "#3d0c02",
];

const availableTypes = [
  {
    name: 'note',
    svg: '<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0z"></path><path d="M7 17V9.93L13.93 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-8.93L14.07 17H7z"></path><path d="M9 15h4.24l7.2-7.2-4.24-4.24-7.2 7.2zM22.91 2.49 21.5 1.08c-.78-.78-2.05-.78-2.83 0l-1.06 1.06 4.24 4.24 1.06-1.06c.79-.78.79-2.05 0-2.83z"></path></svg>'
  },
  {
    name: 'todo',
    svg: '<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M152.1 38.2c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 113C-2.3 103.6-2.3 88.4 7 79s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zm0 160c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 273c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zM224 96c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32zM160 416c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32zM48 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"></path></svg>'
  },
  {
    name: 'sketch',
    svg: '<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M10.0357 7.69802C8.38492 9.55932 6.5134 12.2442 4.89465 15.4817C4.64766 15.9757 4.04698 16.1759 3.55301 15.9289C3.05903 15.6819 2.8588 15.0812 3.10579 14.5873C4.79739 11.2041 6.76494 8.37171 8.53943 6.37095C9.4251 5.37234 10.2797 4.56162 11.0449 3.99131C11.4272 3.7063 11.8049 3.46806 12.1677 3.29756C12.5193 3.13234 12.921 3 13.3336 3C13.5496 3 13.7872 3.0535 14.007 3.19476C14.2233 3.33371 14.3629 3.51925 14.4495 3.69083C14.6066 4.00215 14.624 4.33473 14.6201 4.55938C14.6118 5.03651 14.4847 5.6328 14.3216 6.23975C13.9874 7.48318 13.3994 9.13104 12.8149 10.7577L12.7329 10.9858C12.1671 12.5598 11.6101 14.1093 11.248 15.3466C11.1505 15.68 11.0706 15.9792 11.0094 16.2414C11.7035 15.6835 12.5581 14.8454 13.466 13.9534L13.4956 13.9243C14.3772 13.0581 15.3098 12.1418 16.0967 11.5127C16.4872 11.2006 16.9082 10.904 17.3138 10.7322C17.6544 10.5878 18.4343 10.3532 19.0407 10.9596C19.4251 11.344 19.5318 11.8438 19.5594 12.2164C19.5883 12.6064 19.5429 13.0267 19.4725 13.4261C19.3315 14.2258 19.0483 15.159 18.7894 16.0009L18.7478 16.136C18.5165 16.8874 18.3102 17.5577 18.1926 18.0965C18.4529 17.8352 18.7734 17.4216 19.1475 16.811C19.436 16.34 20.0517 16.1921 20.5226 16.4806C20.9935 16.7691 21.1414 17.3848 20.8529 17.8557C20.3099 18.7422 19.748 19.4622 19.1519 19.9092C18.5283 20.377 17.7121 20.6407 16.8863 20.2278C16.2779 19.9235 16.1398 19.3173 16.1091 18.9819C16.0759 18.6192 16.1284 18.2233 16.1979 17.8667C16.3288 17.1944 16.5829 16.3698 16.823 15.5907L16.8777 15.4129C17.1447 14.5451 17.3873 13.734 17.5028 13.0789C17.5117 13.0284 17.5196 12.9802 17.5266 12.9341C17.4697 12.977 17.4094 13.0239 17.3455 13.0749C16.6477 13.6328 15.785 14.4788 14.8677 15.38L14.8381 15.4091C13.9566 16.2752 13.024 17.1915 12.2371 17.8206C11.8466 18.1328 11.4255 18.4293 11.02 18.6012C10.6794 18.7455 9.89947 18.9801 9.29311 18.3738C8.9843 18.065 8.9052 17.6753 8.87972 17.4382C8.8515 17.1755 8.86901 16.8971 8.90269 16.6351C8.9706 16.1069 9.12934 15.4656 9.32855 14.7849C9.70829 13.4872 10.2842 11.8852 10.8411 10.3362L10.9327 10.0814C11.5263 8.42931 12.082 6.8674 12.3901 5.72074C12.4172 5.61968 12.4418 5.52435 12.4638 5.43468C12.3924 5.48361 12.3178 5.53695 12.2401 5.59489C11.6173 6.05907 10.8627 6.76559 10.0357 7.69802Z"></path></svg>'
  },
  {
    name: 'image',
    svg: '<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M464 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM112 120c-30.928 0-56 25.072-56 56s25.072 56 56 56 56-25.072 56-56-25.072-56-56-56zM64 384h384V272l-87.515-87.515c-4.686-4.686-12.284-4.686-16.971 0L208 320l-55.515-55.515c-4.686-4.686-12.284-4.686-16.971 0L64 336v48z"></path></svg>'
  },
  {
    name: 'audio',
    svg: '<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 1024 1024" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M512 624c93.9 0 170-75.2 170-168V232c0-92.8-76.1-168-170-168s-170 75.2-170 168v224c0 92.8 76.1 168 170 168zm330-170c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 140.3-113.7 254-254 254S258 594.3 258 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 168.7 126.6 307.9 290 327.6V884H326.7c-13.7 0-24.7 14.3-24.7 32v36c0 4.4 2.8 8 6.2 8h407.6c3.4 0 6.2-3.6 6.2-8v-36c0-17.7-11-32-24.7-32H548V782.1c165.3-18 294-158 294-328.1z"></path></svg>'
  }
];

function Cards() {
  const { cards, Local, setLocal } = useData();
  const [results, setResults] = useState(cards);
  const [Color, setColor] = useState('');
  const [Type, setType] = useState('');

  useEffect(() => {
    handleSearch();
  }, [Color, Type])

  const handleSearch = () => {
    if (Type && Color) {
      setResults(
        cards.filter((card) =>
          card.type == Type && card.color == Color
        )
      );
    }
    else if (Type) {
      setResults(
        cards.filter((card) =>
          card.type == Type
        )
      );
    }
    else if (Color) {
      setResults(
        cards.filter((card) =>
          card.color == Color
        )
      );
    }
    else {
      setResults(cards);
    }
  }

  const renderCardHeader = (name) => (
    <div className="w-fit px-2 py-1 rounded-md bg-white text-main">
      {name.length <= 10 ? name : `${name.slice(0, 10)}..`}
    </div>
  );

  const handleCardClick = (data) => {
    setLocal(data);
    localStorage.setItem('embed', btoa(data.ncid));
  };

  const renderCardContent = (card) => {
    switch (card.type) {
      case "image":
        return (
          <div onClick={() => handleCardClick(card)} className="relative bg-white border shadow-sm rounded-md" style={{ backgroundColor: card.color }}>
            <img className="w-full h-[300px] object-cover rounded-md" src={card.data} alt={card.name} />
            <div className="absolute top-3 start-3">
              {renderCardHeader(card.name)}
            </div>
          </div>
        );
      case "note":
        return (
          <div onClick={() => handleCardClick(card)} className="h-[300px] p-3 border rounded-md shadow-sm" style={{ backgroundColor: card.color }}>
            <div className="flex justify-between">{renderCardHeader(card.name)}</div>
            <div className="h-[200px] my-2">
              <div dangerouslySetInnerHTML={{ __html: generateHTML(card.data) }} />
            </div>
          </div>
        );
      case "todo":
        return (
          <div onClick={() => handleCardClick(card)} className="h-[300px] p-3 border rounded-md shadow-sm" style={{ backgroundColor: card.color }}>
            <div className="flex justify-between">{renderCardHeader(card.name)}</div>
            <ul className="list-disc h-[200px] p-4 list-inside mb-2">
              {card.data?.blocks?.[0]?.data?.items?.slice(0, 5).map((todo, index) => (
                <li key={index} className={`text-gray-700 ${todo.checked ? "line-through" : ""}`}>
                  {todo.text}
                </li>
              ))}
            </ul>
          </div>
        );
      case "sketch":
        return (
          <div onClick={() => handleCardClick(card)} className="h-[300px] p-3 border rounded-md shadow-sm" style={{ backgroundColor: card.color }}>
            <div className="flex justify-between">{renderCardHeader(card.name)}</div>
            <div className="h-[200px] my-2" dangerouslySetInnerHTML={{ __html: card.data }} />
          </div>
        );
      case "audio":
        return (
          <div onClick={() => handleCardClick(card)} className="h-[300px] p-3 border rounded-md shadow-sm" style={{ backgroundColor: card.color }}>
            <div className="flex justify-between">{renderCardHeader(card.name)}</div>
            <div className="h-[200px] flex items-center justify-center p-4">
              <MdOutlinePlayCircleFilled className="text-8xl text-white border-dashed border-[3px] border-white rounded-full" />
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  const renderCardContents = (card) => {
    switch (card.type) {
      case "image":
        return (
          <div onClick={() => handleCardClick(card)} className="relative bg-white border shadow-sm rounded-md" style={{ backgroundColor: card.color }}>
            <img className="w-full h-[300px] object-cover rounded-md" src={card.data} alt={card.name} />
            <div className="absolute top-3 start-3">
              {renderCardHeader(card.name)}
            </div>
          </div>
        );
      case "note":
        return (
          <div onClick={() => handleCardClick(card)} className="h-[300px] p-3 border rounded-md shadow-sm" style={{ backgroundColor: card.color }}>
            <div className="flex justify-between">{renderCardHeader(card.name)}</div>
            <div className="h-[200px] my-2">
              <div dangerouslySetInnerHTML={{ __html: generateHTML(card.data) }} />
            </div>
          </div>
        );
      case "todo":
        return (
          <div onClick={() => handleCardClick(card)} className="h-[300px] p-3 border rounded-md shadow-sm" style={{ backgroundColor: card.color }}>
            <div className="flex justify-between">{renderCardHeader(card.name)}</div>
            <ul className="list-disc h-[200px] p-4 list-inside mb-2">
              {card.data?.blocks?.[0]?.data?.items?.slice(0, 5).map((todo, index) => (
                <li key={index} className={`text-gray-700 ${todo.checked ? "line-through" : ""}`}>
                  {todo.text}
                </li>
              ))}
            </ul>
          </div>
        );
      case "sketch":
        return (
          <div onClick={() => handleCardClick(card)} className="h-[300px] p-3 border rounded-md shadow-sm" style={{ backgroundColor: card.color }}>
            <div className="flex justify-between">{renderCardHeader(card.name)}</div>
            <div className="h-[200px] my-2" dangerouslySetInnerHTML={{ __html: card.data }} />
          </div>
        );
      case "audio":
        return (
          <div onClick={() => handleCardClick(card)} className="h-[300px] p-3 border rounded-md shadow-sm" style={{ backgroundColor: card.color }}>
            <div className="flex justify-between">{renderCardHeader(card.name)}</div>
            <div className="h-[200px] flex items-center justify-center p-4">
              <MdOutlinePlayCircleFilled className="text-8xl text-white border-dashed border-[3px] border-white rounded-full" />
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  const renderCardsGrid = () => (
    <div className="grid gap-5 h-[78vh] pb-5 overflow-y-auto px-3 md:grid-cols-1 grid-cols-1 lg:grid-cols-2 sm:grid-cols-2 xl:grid-cols-3">
      {results.map((card, index) => <div key={index}>{renderCardContent(card)}</div>)}
    </div>
  );

  return (
    <div>
      {Object.keys(Local).length > 0 ? (
        <div>{renderCardContents(Local)}</div>
      ) : (
        <div className="p-3" >
          <div className="w-full h-[280px] flex border-dashed border-2 border-white rounded-lg items-center justify-center">
            <Dialog.Root>
              <Dialog.Trigger asChild>
                <button>
                  <FiPlusCircle className="text-9xl text-white active:scale-95 transition-all" />
                </button>
              </Dialog.Trigger>
              <Dialog.Portal>
                <Dialog.Overlay className="bg-blackA6 data-[state=open]:animate-overlayShow fixed inset-0" />
                <Dialog.Content className={`data-[state=open]:animate-slideDown fixed bottom-0 left-0 h-[90vh] w-full rounded-t-2xl bg-white shadow-md focus:outline-none`}>
                  {cards.length < 1 ?
                    <div className="flex items-center flex-col w-full h-[90vh] px-3 justify-center mb-5">
                      <img src="https://ik.imagekit.io/vituepzjm/No%20data-pana.svg?updatedAt=1724334371763" alt="NO DATA" className="size-72" />
                      <p className="text-main text-xl break-words">Not Created Any Cards and Books Yet :( </p>
                    </div>
                    : <div className="md:px-5 px-1 pt-5">
                      <div className="flex items-center px-3 justify-between mb-5">
                        <p className="px-3 py-2 rounded-md bg-main text-white">Your Cards</p>

                        <Popover.Root>
                          <Popover.Trigger asChild>
                            <button className="p-2.5 ml-2 text-sm font-medium text-white bg-main rounded-lg border border-main transition-all active:scale-95 focus:outline-none">
                              <FaFilter className="text-[1rem]" />
                            </button>
                          </Popover.Trigger>
                          <Popover.Portal>
                            <Popover.Content sideOffset={5} side="bottom" className=" z-[100] rounded-lg px-5 py-4 bg-white focus:outline-none border border-main/60 me-5 md:me-8 shadow-lg w-fit">
                              <div className="pb-3">
                                <h1 className="text-main mb-3">Colors</h1>
                                <div className={`grid gap-3 place-items-center ${availableColors.length > 5 ? "grid-cols-5" : "grid-cols-3"}`}>
                                  <button
                                    onClick={() => setColor('')}
                                    style={{
                                      borderColor: '' === Color ? '#1a1a1a' : ''
                                    }}
                                    className="p-2 bg-gray-100 text-gray-400 rounded-md border"
                                  >
                                    <PiEmptyBold />
                                  </button>

                                  {availableColors.map((item, index) => (
                                    <button
                                      key={index}
                                      onClick={() => setColor(item)}
                                      style={{ backgroundColor: item, borderColor: item === Color ? '#1a1a1a' : '' }}
                                      className="w-8 h-8 rounded-md border"
                                    />
                                  ))}
                                </div>
                              </div>
                              <div className="pb-3">
                                <h1 className="text-main mb-3">Types</h1>
                                <div className={`grid gap-3 place-items-center ${availableColors.length > 5 ? "grid-cols-5" : "grid-cols-3"}`}>
                                  <button
                                    onClick={() => setType('')}
                                    style={{
                                      borderColor: '' === Type ? '#1a1a1a' : ''
                                    }}
                                    className={`p-2 bg-gray-100 text-gray-400 rounded-md border`}
                                  >
                                    <PiEmptyBold />
                                  </button>
                                  {availableTypes.map((item, index) => (
                                    <button
                                      key={index}
                                      className={`focus:outline-none ${item.name == Type ? 'text-main' : 'text-gray-400'}`}
                                      onClick={() => setType(item.name)}
                                      dangerouslySetInnerHTML={{ __html: item.svg }}
                                    />
                                  ))}

                                </div>
                              </div>
                              <Popover.Arrow className="fill-main/60" />
                            </Popover.Content>
                          </Popover.Portal>
                        </Popover.Root>
                      </div>
                      {renderCardsGrid()}
                    </div>}
                </Dialog.Content>
              </Dialog.Portal>
            </Dialog.Root>
          </div>
        </div>
      )}
    </div>
  );
}

export default Cards;